import { initPostsListAsync } from "../postsList";

initPostsListAsync();
